import { PageHeader } from "@/components/PageHeader";
import { ChurchMessages } from "@/components/messages/ChurchMessages";
import { AdminMessages } from "@/components/messages/AdminMessages";
import { useApp } from "@/context/AppContext";

export default function Messages() {
  const { isAdmin, myChurch } = useApp();
  return (
    <div>
      <PageHeader eyebrow={isAdmin ? "Shared admin inbox" : myChurch?.name} title="Messages"
        subtitle={isAdmin ? "Read and reply to churches, or send a message to one person, some churches, or everyone." : "Send a message to the MWJK admin team. You can attach reports, documents or photos."} />
      {isAdmin ? <AdminMessages /> : <ChurchMessages />}
    </div>
  );
}
